import { Music2 } from 'lucide-react'
import type { ActivityEntry, Discipline } from '@/hooks/useDashboardChannel'
import { timeAgo } from '@/lib/format'
import { workoutNouns } from '@/lib/discipline'

interface ActivityFeedProps {
  entries: ActivityEntry[]
  discipline: Discipline
}

export function ActivityFeed({ entries, discipline }: ActivityFeedProps) {
  if (entries.length === 0) {
    const { singular } = workoutNouns(discipline)
    return <p className="text-sm text-muted-foreground">Waiting for the first {singular} to sync...</p>
  }

  return (
    <ul className="flex max-h-[360px] flex-col gap-1 overflow-y-auto">
      {entries.map((entry, index) => (
        <li
          key={entry.id}
          className={`flex items-center gap-3 rounded-lg px-2 py-2 ${index === 0 ? 'activity-enter' : ''}`}
        >
          <div className="flex size-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
            <Music2 className="size-4" />
          </div>
          <div className="flex min-w-0 flex-1 flex-col">
            <span className="truncate text-sm font-medium">{entry.title}</span>
            <span className="truncate text-xs text-muted-foreground">
              {entry.instructor_name ?? 'Unknown instructor'} &middot; {entry.song_count} songs
            </span>
          </div>
          <span className="shrink-0 text-xs tabular-nums text-muted-foreground">
            {index === 0 ? 'just now' : timeAgo(entry.synced_at)}
          </span>
        </li>
      ))}
    </ul>
  )
}
